import React from 'react'

const ModalHeading = ({ children, className }) => {
    return (
        <h1 className={` lg:text-xl text-lg font-bold ${className}`}>
            {children}
        </h1>
    )
}

export default ModalHeading
